import { GridColDef } from "@mui/x-data-grid-pro";
import { IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import ItemStatus from "../../../../../../common/components/item_status";


type Props = {
    onActionEdit: (idCliente: number | null, openState: boolean) => void,
    onActionDelete: (idCliente: number | null, openState: boolean) => void,

}

export const GenerateSubcontasListaColumns = ({
    onActionEdit,
    onActionDelete,

}: Props): GridColDef[] => {
    const computeItemStatusTitle = (status: boolean) => {
        switch (status) {
            case false:
                return "Inativo";
            case true:
                return "Ativo";
            default:
                return "?";
        }
    };

    const computeItemStatusColor = (status: boolean) => {
        switch (status) {
            case false:
                return "red";
            case true:
                return "green";
            default:
                return "blue";
        }
    };

    const computeItemStatusDescription = (status: boolean) => {
        switch (status) {
            case false:
                return "Inativo";
            case true:
                return "Ativo";
            default:
                return "?";
        }
    };

    return [
        {
            field: "descricao",
            filterable: false,
            headerName: "Subconta",
            flex: 1,
            minWidth: 400,
            sortable: false,
        },
        {
            field: "ativo",
            filterable: false,
            headerName: "Status",
            minWidth: 75,
            width: 75,
            sortable: false,
            renderCell: (params) => (
                <div className="w-full h-full flex justify-center items-center">
                    <ItemStatus
                        size="autowidth"
                        title={computeItemStatusTitle(params.value)}
                        color={computeItemStatusColor(params.value)}
                        description={computeItemStatusDescription(params.value)} />
                </div>
            )
        },

        {
            field: 'idSubconta',
            sortable: false,
            filterable: false,
            headerName: 'Ações',
            minWidth: 150,
            renderCell: (params) => {
                return (
                    <div className="flex items-center justify-center w-full h-full gap-2">

                        <IconButton onClick={() => onActionEdit(params.value, true)}>
                            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
                        </IconButton>

                        <IconButton onClick={() => onActionDelete(params.value, true)}>
                            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
                        </IconButton>

                    </div>
                );
            }
        }

    ];

}